import React from "react";
import RadioButton from "../RadioButton";
import { Spacer, Stack, Typography } from "digiwash-components";
import { Image, TouchableOpacity } from "react-native";
import CustomIcon from "../CustomIcon";

interface RadioRowType {
  title: string;
  onSelect: () => void;
  selected: boolean;
  icon: string;
}

function RadioRow(props: RadioRowType) {
  return (
    <TouchableOpacity
      onPress={() => {
        props.onSelect();
      }}
    >
      <Stack distribution="space-between">
        <Stack>
          {props.icon === "personal" ? (
            <CustomIcon icon={props.icon} width={24} height={24} />
          ) : (
            <Image source={props.icon} style={{ width: 24, height: 24 }} />
          )}

          <Spacer size="m" />
          <Typography color="gray.light950" ff="mainMedium">
            {props.title}
          </Typography>
        </Stack>
        <RadioButton selected={props.selected} />
      </Stack>
    </TouchableOpacity>
  );
}

export default RadioRow;
